import { ElementRef } from '@angular/core';

export const scrollElementIntoView = (element: ElementRef<unknown> | undefined | null): void => {
  if (!element) {
    return;
  }
  const nativeElement = element.nativeElement as { scrollIntoView: (arg: boolean, options: { behavior: 'instant' }) => void };
  nativeElement.scrollIntoView(false, { behavior: 'instant' });
};
